import styled from 'styled-components'

export default styled.div<Props>`
    display: flex;
    width: ${props => props.width || "auto"};
    justify-content: ${props => props.justifyContent || null};
    align-items: ${props => props.alignItems || null};
    flex-direction: ${props => props.flexDirection || null};
    flex-wrap: ${props => props.flexWrap || null};
    margin: ${props => props.gap ? `-${props.gap}` : null};

    & > * {
        margin: ${props => props.gap || null};
    }

    & > h1, & > h2, & > h3, & > h4, & > h5, & > h6, & > p {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
    }
`

// TYPES
interface Props {
    justifyContent?: string,
    alignItems?: string,
    gap?: string,
    flexDirection?: string,
    flexWrap?: string
    width?: string
}